import { render, staticRenderFns } from "./InspectionStandardPoint.vue?vue&type=template&id=0f590b50&scoped=true&"
import script from "./InspectionStandardPoint.vue?vue&type=script&lang=js&"
export * from "./InspectionStandardPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f590b50",
  null
  
)

export default component.exports